export const getFirstNameLastNameArray = (val: any) => {
  if (val) {
    return val
      .replace(/Azure-SSO_/, '')
      .replace(/@.*$/, '')
      .split('.');
  }
  return [''];
};

export const getUserEmail = (val: any) => {
  if (val) {
    val = val.replace(/Azure-SSO_/, '');
    return val;
  }
  return [''];
};

export const getUserInitialsFromName = (fullName: string) => {
  if (!fullName || typeof fullName !== 'string') return '??';

  const normalizedName = fullName.trim().replace(/\s+/g, ' ');
  if (normalizedName === '') return '??';
  const nameParts = normalizedName.split(' ').filter((part) => part.length > 0);

  // Handle single name
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }

  // For multiple name parts
  if (nameParts.length >= 2) {
    // First initial + last name initial
    return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
  }

  return '??';
};
